module.exports = __webpack_public_path__ + "static/img/share_web.100cab4e.png";